import * as Constants from '../../constants';

import { useState, useEffect, useCallback } from 'react';

import classes from "./AcoesList.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";
import { faFilter } from '@fortawesome/free-solid-svg-icons';

import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';

import ScrollContainer from '../../components/UI/ScrollContainer';
import Card from '../../components/UI/Card';

import Loading from '../../components/UI/Loading';
import AcoesFilterForm from '../../components/AcoesFilterForm';

const nroFormatter = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

const brlFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

const percentageFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

// const defaultFormAsset = { id: 0, ticker: 0, quotas: 0, price: 0 };

function AcoesList(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [acoes, setAcoes] = useState([]);
  const [filters, setFilters] = useState([]);
  const [filtersText, setFiltersText] = useState("");
  const [acoesFiltradas, setAcoesFiltradas] = useState([]);
  const [filterFormIsShown, setFilterFormIsShown] = useState(false);
  const [lastUpdate, setLastUpdate] = useState("");

  const fetchAcoesHandler = useCallback(async () => {
    setIsLoading(true);
    try {
      const lastUpdateReponse = await fetch(Constants.PUBLIC_ACOES_LAST_UPDATE);
      const lastUpdateData = await lastUpdateReponse.json();
      setLastUpdate(lastUpdateData);

      const response = await fetch(Constants.PUBLIC_ACOES_LIST);
      if (!response.ok) {
        alert('deu pau');
        throw new Error('Something went wrong!');
      }

      const data = await response.json();
      const loadedAcoes = [];

      for (let item in data) {
        const i = data[item];
        // console.warn(i);
        let acao = {
          id: i.id,
          ticker: i.ticker,
          setor: i.sector,
          subsetor: i.subsector,
          lqd: i.lqd,
          price: i.currentPrice,
          pL: i.pL,
          dLpL: i.dLpL,
          mL: i.mL,
          mB: i.mB,
          mE: i.mE,
          roa: i.roa,
          roe: i.roe,
          roic: i.roic,
          pvp: i.pvp,
          d: i.d,
          dy: i.dy,
          cagrR5: i.cagrR5,
          cagrL5: i.cagrL5,
          vpa: i.vpa,
          lpa: i.lpa,
          payout: i.payout,
          vD: i.vD,
          vM: i.vM,
          vY: i.vY,
          evEbitda: i.evEbitda,
          ey: (i.evEbitda && i.evEbitda !== '' ? 1 / i.evEbitda : '')
        }
        loadedAcoes.push(acao);
      }
      setAcoes(loadedAcoes);
      setAcoesFiltradas(loadedAcoes);
    } catch (error) {
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    fetchAcoesHandler();
  }, [fetchAcoesHandler]);

  useEffect(() => {
    if (acoes.length > 0)
      setIsLoading(false);
  }, [acoes]);

  useEffect(() => {
    let str = "";
    if (Object.keys(filters).length > 0) {
      str += '<strong style="color:#0A58CA">' + Object.keys(filters).length + ' filtro(s) aplicado(s)</strong>: ';
      str += (filters.codigo && filters.codigo.value && filters.codigo.value.length > 0 ? "<strong>Código</strong> contém '" + filters.codigo.value + "', " : "");
      str += (filters.setor && filters.setor.value && filters.setor.value.length > 0 ? "<strong>Setor</strong> contém '" + filters.setor.value + "', " : "");
      str += (filters.subsetor && filters.subsetor.value && filters.subsetor.value.length > 0 ? "<strong>Segmento:</strong> contém '" + filters.subsetor.value + "', " : "");
      str += (filters.lqd && filters.lqd.operator !== "" ? "<strong>Liquidez diária</strong> " + filters.lqd.operator + " " + brlFormatter.format(filters.lqd.value) + ", " : "");
      str += (filters.evEbitda && filters.evEbitda.operator !== "" ? "<strong>Ev/Ebitda</strong> " + filters.evEbitda.operator + " " + filters.evEbitda.value + "%, " : "");
      str += (filters.roe && filters.roe.operator !== "" ? "<strong>ROE</strong> " + filters.roe.operator + " " + brlFormatter.format(filters.roe.value) + ", " : "");
      str += (filters.roic && filters.roic.operator !== "" ? "<strong>ROIC</strong> " + filters.roic.operator + " " + filters.roic.value + "%, " : "");
      str += "<br/>";
      str += (filters.mL && filters.mL.operator !== "" ? "<strong>Margem Líquida</strong> " + filters.mL.operator + " " + filters.mL.value + "%, " : "");
      str += (filters.dLpL && filters.dLpL.operator !== "" ? "<strong>Dívida Líquida/PL</strong> " + filters.dLpL.operator + " " + filters.dLpL.value + "%, " : "");
      str += (filters.pvp && filters.pvp.operator !== "" ? "<strong>P/VP</strong> " + filters.pvp.operator + " " + filters.pvp.value + ", " : "");
      str += (filters.dy && filters.dy.operator !== "" ? "<strong>Dividend Yield</strong> " + filters.dy.operator + " " + filters.dy.value + "%, " : "");
      str += (filters.vD && filters.vD.operator !== "" ? "<strong>Variação 1Dia</strong> " + filters.vD.operator + " " + filters.vD.value + "%, " : "");
      str += (filters.vM && filters.vM.operator !== "" ? "<strong>Variação 1Mês</strong> " + filters.vM.operator + " " + filters.vM.value + "%, " : "");
      str += (filters.vY && filters.vY.operator !== "" ? "<strong>Variação 1Ano</strong> " + filters.vY.operator + " " + filters.vY.value + "%, " : "");
      str += (filters.price && filters.price.operator !== "" ? "<strong>Preço</strong> " + filters.price.operator + " R$ " + filters.price.value + ", " : "");
      str = str.substring(0, str.length - 2);
      str += "<br/>";
    }
    if (str.length === 0) str = "<br/><br/>";
    setFiltersText(str);
  }, [filters]);

  const showHideFilterFormHandler = () => {
    setFilterFormIsShown(!filterFormIsShown);
  };

  const closeFilterFormHandler = () => {
    setFilterFormIsShown(false);
  };


  const filtersHandler = (filters) => {
    setFilters(filters);
    setFilterFormIsShown(false);
    const filtered = acoes.filter(item => {
      return Object.keys(filters).every(key => {
        const filtroValor = filters[key]?.value;
        const filtroOperador = filters[key]?.operator;
        const itemValor = item[key];

        // Ignorar se o valor do filtro for undefined, vazio ou zero
        if (filtroValor === undefined || filtroValor === "" || filtroOperador === 0) {
          return true;
        }

        // Para valores string, realizar comparação parcial similar ao LIKE
        if (isNaN(itemValor) && (typeof itemValor === "string" && typeof filtroValor === "string")) {
          return itemValor.toLowerCase().includes(filtroValor.toLowerCase());
        } else {
          // console.warn(key, itemValor, filtroOperador, filtroValor);
          switch (filtroOperador) {
            case ">":
              return Number(itemValor) > Number(filtroValor);
            case ">=":
              return Number(itemValor) >= Number(filtroValor);
            case "<":
              return Number(itemValor) < Number(filtroValor);
            case "<=":
              return Number(itemValor) <= Number(filtroValor);
            case "=":
            default:
              return Number(itemValor) === Number(filtroValor);
          }
        }
      });

    });
    setAcoesFiltradas(filtered);
  };

  const dataAtualFormatada = (dt) => {
    var data = new Date(dt);
    var dia = data.getDate().toString(),
      diaF = (dia.length === 1) ? '0' + dia : dia,
      mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = (mes.length === 1) ? '0' + mes : mes,
      anoF = data.getFullYear(),
      hora = (data.getHours().toString().length === 1) ? '0' + data.getHours() : data.getHours(),
      min = (data.getMinutes().toString().length === 1) ? '0' + data.getMinutes() : data.getMinutes(),
      seg = (data.getSeconds().toString().length === 1) ? '0' + data.getSeconds() : data.getSeconds();

    return diaF + "/" + mesF + "/" + anoF + " " + hora + ":" + min + ":" + seg;
  }

  return <>
    {isLoading && <Loading />}
    {!isLoading && <>
      <div className="row mainPanel">
        <div className="col col-md-12">
          <Card>
            {filterFormIsShown && <AcoesFilterForm
              updateFilters={filtersHandler}
              closeFilterForm={closeFilterFormHandler}
              filters={filters}
            />}
            <div className='row'>
              <div className='col-2'>
                <Button variant="secondary" className={classes.filterButton} onClick={showHideFilterFormHandler}><FontAwesomeIcon icon={faFilter} /></Button>
                &nbsp;&nbsp;
                <small>
                  <strong>{acoesFiltradas.length}</strong> ações encontradas.
                </small>
              </div>
              <div className='col'><small dangerouslySetInnerHTML={{ __html: filtersText }} /></div>
              <div className='col-2'>
                <small className='lastUpdate'><b>Última atualização:</b>&nbsp;&nbsp;{dataAtualFormatada(lastUpdate)}</small>
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <ScrollContainer>
                  <Table striped bordered hover>
                    <thead className={`fixedTableHead ${classes.fixedTableHead}`}>
                      <tr>
                        <th rowSpan="2" className="text-center">CÓDIGO</th>
                        <th rowSpan="2">Setor<br /><small>Segmento</small></th>
                        <th rowSpan="2" className={classes.th}>Liquidez<br />Diária</th>
                        <th colSpan="3" className={classes.yellow4}>Margem</th>
                        <th rowSpan="2">EV/EBITDA<br /><small>Earning Yield</small></th>
                        <th rowSpan="2">P/L</th>
                        <th rowSpan="2">Dívida<br />Líquida/PL</th>
                        <th rowSpan="2">P/VP</th>
                        <th colSpan="1" rowSpan="2">Dividendos<br />12 Meses</th>
                        <th rowSpan="2" className={classes.th}>ROA</th>
                        <th rowSpan="2" className={classes.th}>ROE</th>
                        <th rowSpan="2" className={classes.th}>ROIC</th>
                        <th rowSpan="2" className={classes.th}>CAGR<br />Receita<br />5 anos</th>
                        <th rowSpan="2" className={classes.th}>CAGR<br />Lucro<br />5 anos</th>
                        <th rowSpan="2">VPA<br />LPA</th>
                        <th rowSpan="2" className={classes.th}>Payout</th>
                        <th colSpan="3" className={classes.yellow4}>Variação</th>
                        <th colSpan="1" rowSpan="2">Preço Atual</th>
                      </tr>
                      <tr>
                        <th className={classes.yellow3}>Líquida</th>
                        <th className={classes.yellow2}>Bruta</th>
                        <th className={classes.yellow1}>EBITDA</th>
                        <th className={classes.yellow3}>1 Dia</th>
                        <th className={classes.yellow2}>1 Mês</th>
                        <th className={classes.yellow1}>1 Ano</th>
                      </tr>
                    </thead>
                    <tbody>
                      {acoes.length === 0 && <tr>
                        <td colSpan='20'>Nenhum ativo cadastrado.</td>
                      </tr>
                      }
                      {
                        acoesFiltradas.map((acao) => <tr key={acao.id}>
                          <td className={classes.td + " text-center"}>
                            <span className="font-weight-bolder">{acao.ticker}</span><br />
                            <a href={`${Constants.BASE_URL_BRA_ACAO_STATUSINVEST}${acao.ticker}`} target='_blank' rel="noreferrer" title='StatusInvest'>
                              <FontAwesomeIcon icon={faExternalLink} />
                            </a>&nbsp;&nbsp;
                            <a href={`${Constants.BASE_URL_BRA_ACAO_INFOMONEY}${acao.ticker}`} target='_blank' rel="noreferrer" title='InfoMoney'>
                              <FontAwesomeIcon icon={faExternalLink} />
                            </a>&nbsp;&nbsp;
                            <a href={`${Constants.BASE_URL_BRA_ACAO_INVESTIDOR10}${acao.ticker}`} target='_blank' rel="noreferrer" title='Investidor10'>
                              <FontAwesomeIcon icon={faExternalLink} />
                            </a>
                          </td>
                          <td className={classes.td}>{acao.setor}<br /><small>{acao.subsetor}</small></td>
                          <td className={classes.td}><small>{acao.lqd !== '' && !isNaN(acao.lqd) ? brlFormatter.format(acao.lqd) : ""}</small></td>
                          <td className={classes.td + "" + (acao.mL < 1 ? " text-danger" : "")}>{acao.mL !== '' && !isNaN(acao.mL) ? percentageFormatter.format(acao.mL / 100) : ""}</td>
                          <td className={classes.td + "" + (acao.mB < 1 ? " text-danger" : "")}>{acao.mB !== '' && !isNaN(acao.mB) ? percentageFormatter.format(acao.mB / 100) : ""}</td>
                          <td className={classes.td + "" + (acao.mE < 1 ? " text-danger" : "")}>{acao.mE !== '' && !isNaN(acao.mE) ? percentageFormatter.format(acao.mE / 100) : ""}</td>
                          <td className={classes.td}>{acao.evEbitda !== '' && !isNaN(acao.evEbitda) ? nroFormatter.format(acao.evEbitda) : ""}<br /><small>{acao.ey !== '' && !isNaN(acao.ey) ? percentageFormatter.format(acao.ey) : ""}</small></td>
                          <td className={classes.td}>{acao.pL !== '' && !isNaN(acao.pL) ? nroFormatter.format(acao.pL) : ""}</td>
                          <td className={classes.td}>{acao.dLpL !== '' && !isNaN(acao.dLpL) ? nroFormatter.format(acao.dLpL) : ""}</td>
                          <td className={classes.td + "" + (acao.pvp < 1 ? " text-success" : "")}>{acao.pvp !== '' && !isNaN(acao.pvp) ? nroFormatter.format(acao.pvp) : ""}</td>
                          <td className={classes.td}>{acao.vD !== '' && !isNaN(acao.dy) ? percentageFormatter.format(acao.dy / 100) : ""}<br /><small>{acao.d !== '' && !isNaN(acao.d) ? brlFormatter.format(acao.d) : ""}</small></td>
                          <td className={classes.td}>{acao.roa !== '' ? percentageFormatter.format(acao.roa / 100) : ""}</td>
                          <td className={classes.td}>{acao.roe !== '' ? percentageFormatter.format(acao.roe / 100) : ""}</td>
                          <td className={classes.td}>{acao.roic !== '' ? percentageFormatter.format(acao.roic / 100) : ""}</td>
                          <td className={classes.td}>{acao.cagrR5 !== '' ? percentageFormatter.format(acao.cagrR5 / 100) : ""}</td>
                          <td className={classes.td}>{acao.cagrL5 !== '' ? percentageFormatter.format(acao.cagrL5 / 100) : ""}</td>
                          <td className={classes.td}>{acao.vpa !== '' && !isNaN(acao.vpa) ? nroFormatter.format(acao.vpa) : "-"}<br />{acao.lpa !== '' ? nroFormatter.format(acao.lpa) : ""}</td>
                          <td className={classes.td}>{acao.payout !== '' && !isNaN(acao.payout) ? percentageFormatter.format(acao.payout / 100) : ""}</td>
                          <td className={classes.td + "" + (acao.vD < 0 ? " text-danger" : "")}>{acao.vD !== '' && !isNaN(acao.vD) ? percentageFormatter.format(acao.vD / 100) : ""}</td>
                          <td className={classes.td + "" + (acao.vM < 0 ? " text-danger" : "")}>{acao.vM !== '' && !isNaN(acao.vM) ? percentageFormatter.format(acao.vM / 100) : ""}</td>
                          <td className={classes.td + "" + (acao.vY < 0 ? " text-danger" : "")}>{acao.vY !== '' && !isNaN(acao.vY) ? percentageFormatter.format(acao.vY / 100) : ""}</td>
                          <td className={classes.td}>{brlFormatter.format(acao.price)}</td>
                        </tr>
                        )
                      }
                    </tbody>
                  </Table>
                </ScrollContainer>
              </div>
            </div>
          </Card>
        </div>
      </div>
      <div className="row adPanel">
        <div className='col'>sdafads<br />sdafads<br />sdafads<br /></div>
      </div>
    </>
    }
  </>
}

export default AcoesList;
